import React from 'react';
import moment from "moment";
import { includes } from "lodash";
import classNames from "classnames";

function ActionItem({
  item,
  onClick,
}) {
  const validActions = [
    "add_contact",
    "add_supporting_document",
    "change_image",
    "append_image",
    "ptp_resubmit",
    "btp_resubmit",
    "notify_draft_trade_doc",
    "resubmit_creditboost",
    "no_buyer_stamp_on_document",
    "additional_supporting_documents_needed",
    "blurry_image",
    "cropped_image",
    "incomplete_pages",
    "grouped_documents",
    "not_endorsed_by_buyer",
    "terms_not_yet_finalized",
    "not_yet_received_by_accounting_department",
    "cannot_contact_buyer",
    "other",
  ]

  if(!includes(validActions, item.fca_action)) return <div />;

  function timeAgo() {
    return moment(item.created_at).fromNow();
  }

  function url() {
    const { owner_type, owner_id, fca_action } = item;
    switch(owner_type) {
      case 'PurchaseOrder':
        return `/purchase_orders/${owner_id}${fca_action === "notify_draft_trade_doc" ? '/new' : null}`;
      case 'Invoice':
        return `/invoices/${owner_id}${fca_action === "notify_draft_trade_doc" ? '/new' : null}`;
      case 'BusinessTrustpass':
        return `/requirements`;
      case 'PersonalTrustpass':
        return `/requirements`;
      case 'FinancialTrustpassDocument':
        return `/credit-boost`;
      default:
        return null;
    }
  }

  function iconClass() {
    return (item.fca_action !== 'notify_draft_trade_doc') ? "materialIcon --small -primary" : "materialIcon --small -warning";
  }

  function buttonClass() {
    return classNames(
      'ds-btn', '--micro', '_widthAuto',
      {'-warning': item.fca_action === 'notify_draft_trade_doc'},
      {'-primary': item.fca_action !== 'notify_draft_trade_doc'},
    )
  }

  function buttonText() {
    switch(item.fca_action) {
      case 'view_loan_offer':
        return 'View Offer';
      case 'notify_draft_trade_doc':
        return 'View';
      default:
        return 'Resubmit';
    }
  }

  return (
    <section className="cardSection _withColumns _simple --micro">
      <i className={iconClass()}>{item.fca_action === 'view_loan_offer' ? 'stars' : 'assignment_late'}</i>
      <div className="text _widthAuto _paddingRight--normal">
        <p className="copy --small _noBottomMargin">
          <b className="emphasize">{item.header}</b><br />
          {item.message}
        </p>
        <small className="byline">{timeAgo()}</small>
      </div>
      <div onClick={() => { onClick(url()) }} className={buttonClass()}>{buttonText()}</div>
    </section>
  );
}

export default ActionItem;



// WEBPACK FOOTER //
// ./src/features/notifications/components/ActionItem.js